import React from 'react';
import "./pending.css";
import Button from '../../../Elements/Button/Button';
import { useNavigate } from 'react-router-dom';

const Pending = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/"); // Redirige al inicio
    };

    return (
        <div className="container-fluid pending-container d-flex justify-content-center align-items-center">
            <div className="pending-card text-center">
                <div className="pending-icon">⏳</div>
                <h1 className="pending-title">Pago en Proceso</h1>
                <p className="pending-message">
                    Tu transacción está siendo verificada.
                    Este proceso puede tardar unos minutos.
                </p>

                {/* Botón reutilizable */}
                <Button
                    text="Volver al inicio"
                    action={handleGoHome}
                    color="purple"
                    fill={true}
                    classNames="mt-3"
                />
            </div>
        </div>
    )
}

export default Pending;